<app-engagement-cards [values]="recordsJourneyData" [isDeviationEnabled]="isDeviationEnabled"></app-engagement-cards>
<button (click)="isLeftCardVisible = !isLeftCardVisible" style="position: fixed;right: 100px;">
    Toggle Left Card
</button>
<div class="engagement-chart-container">
    <div class="row">
      <!-- Left Card (Conditional) -->
      <div *ngIf="isLeftCardVisible" class="col-12 col-md-6">
        <div class="drilldown-table">
          <div class="card-body d-flex justify-content-center align-items-center">
            <app-engagement-records-summary-drilldown [overallData]="recordsJourneyData" [displayName]="displayName" [isDeviationEnabled]="isDeviationEnabled" style="width: 100%;"></app-engagement-records-summary-drilldown>
          </div>
        </div>
      </div>
  
      <!-- Right Cards -->
      <!-- <div class="col-12" [ngClass]="{'col-md-12': !isLeftCardVisible, 'col-md-6': isLeftCardVisible}"> -->
      <div [ngClass]="{'row-md-12': !isLeftCardVisible, 'col-md-6': isLeftCardVisible}">
        <div class="row" [ngClass]="{'flex-row': !isLeftCardVisible, 'flex-column': isLeftCardVisible}">
          <div [ngClass]="{'col-md-6': !isLeftCardVisible, 'col-md-12': isLeftCardVisible}">
            <div class="chart-container">
              <div class="card-body d-flex justify-content-center align-items-center">
                bar chart
              </div>
            </div>
          </div>
          <div [ngClass]="{'col-md-6': !isLeftCardVisible, 'col-md-12': isLeftCardVisible}">
            <div class="chart-container">
              <div class="card-body d-flex justify-content-center align-items-center">
                line chart
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-engagement-channel-performance [data]="recordsJourneyData"></app-engagement-channel-performance>